import {
  Component, ElementRef, OnDestroy, OnInit, ViewChild
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { SegmentChangeEventDetail } from "@ionic/core";
import { UserService } from "src/app/_services";
import { HeaderService } from "src/app/_services/header.service";
import { ThisPlatform } from "src/app/_services/platform.service";
import { HeaderModel } from "../../_component/header/header.model";
import { ConfigService } from "../../_services/config.service";
import { BuildingService } from "../building/building.service";
import { ImagePreviewComponent } from "../_component/image-preview/image-preview.component";
import { InfoService } from "./info.service";

@Component({
  selector: "app-info",
  templateUrl: "./info.page.html",
  styleUrls: ["./../../_styles/ion-grid-box.scss", "./info.page.scss"],
  providers: [HeaderService]
})
export class InfoPage implements OnInit, OnDestroy {
  constructor(
    public infoServ: InfoService,
    public buildingService: BuildingService,
    public modalController: ModalController,
    private config: ConfigService,
    private userServ: UserService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public p: ThisPlatform,
    private headerServ: HeaderService,
  ) { }

  info: any = [];
  toogleInfoState = [];
  firstIdBuilding: number;
  firstIdInfo: number;
  currentQuestion = null;
  currentMenu = null;
  showInfosMenu = false;
  infoLoaded = false;
  previewImgBind;
  bannerImageUrl: string;
  segmentsArray = [];
  showHeader = false;

  headerInit: HeaderModel = {
    segmentsChangeFunc: (event) => this.ChangeBuildingEvent(event),
    mobileSegmentsChangeFunc: (event) => this.ChangeMenu(event),
    title: "INFO",
    userSettingsBreakpoint: 1200,
    showOnTablet: true,
    shouldHasMobileSegments: true,
  };
  
  activeSegment: string;

  async ngOnInit() {
    const url = await this.config.getConfigValue("main_page_banner_link");

    this.previewImgBind = this.previewImg.bind(this);
    document.body.addEventListener("click", this.previewImgBind);

    if (url) {
      this.bannerImageUrl = url;
    } else {
      this.bannerImageUrl = "../../assets/images/banner.jpg";
    }

    await this.infoServ.loadBuildingsSegmentsSync();

    this.headerInit.segments = [];
    for (let i in this.infoServ.buildingsInfo) {
      if (this.infoServ.buildingsInfo[i].buildingInfo != null) {
        this.headerInit.segments.push({
          name: this.infoServ.buildingsInfo[i].name,
          value: this.infoServ.buildingsInfo[i].id.toString(),
          permission: true,
        });
        this.infoLoaded = true;
      }
    }

    this.headerInit.segments.forEach((segment) => {
      this.segmentsArray.push(segment.value);
    });

    this.userServ.getPermision();

    this.activatedRoute.queryParamMap.subscribe((p) => {
      if (p.get("section")) {
        const page = p.get("section");

        if (this.segmentsArray.filter((el) => el === page).length > 0) {
          this.activeSegment = page;
          this.ChangeBuilding(Number(this.activeSegment));
        } else {
          this.activeSegment = this.segmentsArray[0];
          this.setQueryParam();
        }
      } else {
        this.activeSegment = this.segmentsArray[0];
        this.setQueryParam();
        this.headerServ.setHeaderInit(this.headerInit);
      }
    });
  }
  setQueryParam() {
    if (this.activeSegment) {
      setTimeout(() =>
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: {
            section: this.activeSegment,
          },
        })
      );
    }
  }

  async previewImg(event) {
    let e: any = event;
    if (e.target.nodeName == "ION" || e.target.nodeName == "ION-IMG") {
      let src: string = e.target.src;

      if (src && src.length > 0) {
        let modal = await this.modalController.create({
          component: ImagePreviewComponent,
          componentProps: { src: src },
          animated: true,
          cssClass: "image-preview-present",
        });
        modal.present();
      }
    }
  }
  
  ngOnDestroy(): void {
    document.body.removeEventListener("click", this.previewImgBind);
  }

  async ionViewWillEnter() {
    this.firstIdBuilding = Number(this.activeSegment);
    this.ChangeBuilding(Number(this.activeSegment));
  }
  
  ChangeMenu(event: CustomEvent<SegmentChangeEventDetail>) {
    this.currentMenu = this.info.find((x) => x.id == event.detail.value);
  }

  SearchQuestion(info) {
    for (let i in info) {
      if (info[i].questions.length > 0) {
        return info[i].questions[0];
      }
    }

    return null;
  }

  async ChangeBuilding(id: number) {
    this.toogleInfoState = [];
    this.headerInit.mobileSegments = [];

    this.info = this.infoServ.buildingsInfo.find(el => el.id == id).buildingInfo
    this.info = this.info.menu
    
    this.firstIdInfo = this.info.length > 0 ? this.info[0].id : null;
      this.currentQuestion = this.SearchQuestion(this.info);
      this.currentMenu = this.info.length > 0 ? this.info[0] : null;
      this.headerInit.mobileSegments = this.info.map(e => {
        return {
          name: e.name,
          value: e.id.toString(),
          permission: true
        };
      });
      if (this.currentQuestion != null) {
        this.toogleInfoState[this.currentQuestion.idInfoMenu] = true;
      }
      setTimeout(() => {
        this.showHeader = true;
      }, 0);
      
    this.setQueryParam();
    this.headerInit.activeSegment = this.activeSegment;
    this.headerServ.setHeaderInit(this.headerInit);
  }

  ChangeBuildingEvent(event: CustomEvent<SegmentChangeEventDetail>) {
    this.activeSegment = event.detail.value + '';
    this.ChangeBuilding(Number(this.activeSegment));
  }

  toogleInfoSection(info) {
    this.toogleInfoState[info.id] = !this.toogleInfoState[info.id];
  }
  onIonChange(el: ElementRef) {
    if (el) {
      el.nativeElement.scrollIntoView();
    }
  }
}
